import { AppColors } from "@/assets/colors";
import { AppLinks, AppSize, pxToRem } from "@/util";
import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import FeaturedList from "./featuredList";
import Image from "next/image";
import Header from "./header";

export default function FeaturedProperties() {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      <Box className={classes.sub}>
        <Header
          nav={AppLinks.PUBLIC.PORTFOLIOS}
          name={"Featured Properties"}
          isAction={true}
          action={"Explore our Portfolio"}
          description={
            "Explore premium homes and real estate investments tailored for you"
          }
        />

        <FeaturedList />

        <Paper className={classes.property}>
          <Box className={classes.subP}>
            <Typography className={classes.ownP}>Own a property</Typography>
            <Typography className={classes.findP}>
              Find Your Dream Home or Next Investment Opportunity
            </Typography>
            <Typography className={classes.descP}>
              Explore premium properties, secure high-ROI investments, and
              experience top-tier real estate services with Arel Homes
            </Typography>

            <Box className={classes.btnCont}>
              <Button
                href={AppLinks.PUBLIC.LISTINGS}
                className={`${classes.btn} ${classes.viewBtn}`}
                variant="outlined"
              >
                View Available Properties
              </Button>
              <Button
                href={AppLinks.PUBLIC.LISTINGS}
                className={`${classes.btn}`}
                variant="contained"
              >
                Start Investing Today
              </Button>
            </Box>
          </Box>
          <Box className={classes.imgCont}>
            <Image
              src={"/images/home/house_owner.svg"}
              fill
              objectFit="contain"
              alt="man smiling"
            />
          </Box>
        </Paper>
      </Box>
      <Box className={classes.overlay}>
        <Box className={classes.sub2}></Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    minHeight: pxToRem(500),
    display: "grid",
    gridTemplateRows: "1fr",
    paddingTop: theme.spacing(4),
    position: "relative",
    paddingBottom: pxToRem(80),
  },
  overlay: {
    position: "absolute",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "1fr 1fr",
    width: "100%",
    height: "100%",
    zIndex: -1,
  },
  featured: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: theme.spacing(4),
    position: "relative",
  },
  

  ownP: {
    fontWeight: 500,
    fontSize: pxToRem(24),
    lineHeight: "150%",
    letterSpacing: "-1%",
  },

  btn: {
    height: pxToRem(46),
    borderRadius: pxToRem(8),
  },
  viewBtn: {
    color: theme.colors.text,
    marginRight: theme.spacing(2),
  },
  btnCont: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(2),
    },
  },
  findP: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(38),
    width: "80%",
    color: AppColors.secondary["500"],
    lineHeight: "120%",
    letterSpacing: "0%",
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(24),
      width: "100%",
    },
  },
  descP: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    width: "65%",
    lineHeight: "160%",
    letterSpacing: "0%",
    color: AppColors.primary["600"],
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  sub: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
    justifyContent: "center",
    padding: `0px ${pxToRem(AppSize.padding)}`,
    flex: 1,
    [theme.breakpoints.down("sm")]: {
      padding: `0px ${pxToRem(30)}`,
    },
  },
  subP: {
    gap: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
  },

  property: {
    borderRadius: pxToRem(30),
    height: pxToRem(430),
    backgroundColor: AppColors.primary["100"],
    display: "grid",
    gridTemplateColumns: "2fr 1.8fr",
    padding: `${theme.spacing(4)} ${pxToRem(50)}`,
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column-reverse",
      padding: `${theme.spacing(4)} ${pxToRem(20)}`,
      height: "auto", 
      gap: theme.spacing(4),
    },
  },
  imgCont: {
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: pxToRem(250), 
    },
  },
  sub2: {
    backgroundColor: AppColors.secondary["500"],
    gridRowStart: 2,
  },
  featHead: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    alignItems: "center",
    height: pxToRem(150),
  },
  featTxt: {
    color: AppColors.primary["600"],
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(48),
  },
  featDesc: {
    color: AppColors.text.second,
    fontWeight: 400,
    fontSize: pxToRem(20),
  },
}));
